export default __webpack_public_path__ + "static/media/icon-pathway-bbs.2337d9e5.png";